import React, { useEffect, useState } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import ContextMenu from "../../biztran_controls/ContextMenu";

// function PlusSquare(props) {
//   return (
//     <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
//       {/* tslint:disable-next-line: max-line-length */}
//       <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
//     </SvgIcon>
//   );
// }

function PlusSquare(props) {
  return (
    <SvgIcon
      fontSize="inherit"
      viewBox="0 0 64 64"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path
        d="m36.787 44.422c-.163.998-.422 1.962-.771 2.884l3.131 2.837c-.439.924-.939 1.812-1.516 2.646l-4.02-1.296c-.634.775-1.344 1.484-2.119 2.118l1.296 4.02c-.834.577-1.722 1.076-2.646 1.516l-2.837-3.131c-.922.349-1.885.608-2.884.771l-.893 4.136c-.505.04-1.012.077-1.528.077s-1.023-.037-1.529-.077l-.893-4.136c-.998-.163-1.962-.422-2.884-.771l-2.837 3.131c-.924-.439-1.812-.939-2.646-1.516l1.296-4.02c-.775-.634-1.484-1.344-2.118-2.118l-4.02 1.296c-.577-.834-1.076-1.722-1.516-2.646l3.131-2.837c-.349-.922-.608-1.885-.771-2.884l-4.136-.893c-.04-.506-.077-1.013-.077-1.529s.037-1.023.077-1.529l4.136-.893c.163-.998.422-1.962.771-2.884l-3.131-2.837c.439-.924.939-1.812 1.516-2.646l4.02 1.296c.634-.775 1.344-1.484 2.119-2.118l-1.296-4.02c.834-.577 1.722-1.076 2.646-1.516l2.837 3.131c.922-.349 1.885-.608 2.884-.771l.893-4.136c.505-.04 1.012-.077 1.528-.077s1.023.037 1.529.077l.893 4.136c.998.163 1.962.422 2.884.771l2.837-3.131c.924.439 1.812.939 2.646 1.516l-1.296 4.02c.775.634 1.484 1.344 2.118 2.119l4.02-1.296c.577.834 1.076 1.722 1.516 2.646l-3.131 2.837c.349.922.608 1.885.771 2.884l4.136.893c.04.505.077 1.012.077 1.528s-.037 1.023-.077 1.529zm-14.787-12.422c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z"
        fill="#857676"
      />
      <path
        d="m50.659 16.305c-.156.517-.36 1.013-.611 1.48l1.579 3.026c-.533.674-1.141 1.282-1.815 1.815l-3.026-1.579c-.467.252-.963.456-1.48.611l-1.024 3.26c-.422.05-.848.082-1.282.082s-.86-.032-1.281-.081l-1.024-3.26c-.517-.155-1.013-.36-1.48-.611l-3.026 1.579c-.674-.533-1.282-1.141-1.815-1.815l1.579-3.026c-.252-.467-.456-.963-.611-1.48l-3.26-1.024c-.05-.422-.082-.848-.082-1.282s.032-.86.081-1.281l3.26-1.024c.155-.517.36-1.013.611-1.48l-1.579-3.026c.533-.674 1.141-1.282 1.815-1.815l3.026 1.579c.467-.252.963-.456 1.48-.611l1.024-3.26c.422-.05.848-.082 1.282-.082s.86.032 1.281.081l1.024 3.26c.517.155 1.013.36 1.48.611l3.026-1.579c.674.533 1.282 1.141 1.815 1.815l-1.579 3.026c.252.467.456.963.611 1.48l3.26 1.024c.05.422.082.848.082 1.282s-.032.86-.081 1.281zm-7.659-6.305c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
        fill="#857676"
      />
      <path
        d="m58.739 38.871c-.154.555-.371 1.081-.649 1.572l.995 2.094c-.452.577-.971 1.096-1.548 1.548l-2.094-.995c-.49.278-1.017.495-1.572.649l-.778 2.188c-.359.044-.722.073-1.093.073s-.734-.029-1.093-.073l-.778-2.188c-.555-.154-1.081-.371-1.572-.649l-2.094.995c-.577-.452-1.096-.971-1.548-1.548l.995-2.094c-.278-.49-.495-1.017-.649-1.571l-2.188-.778c-.044-.36-.073-.723-.073-1.094s.029-.734.073-1.093l2.188-.778c.154-.555.371-1.081.649-1.571l-.995-2.094c.452-.577.971-1.096 1.548-1.548l2.094.995c.49-.278 1.017-.495 1.572-.649l.778-2.188c.359-.045.722-.074 1.093-.074s.734.029 1.093.073l.778 2.188c.555.154 1.081.371 1.572.649l2.094-.995c.577.452 1.096.971 1.548 1.548l-.995 2.094c.278.49.495 1.017.649 1.572l2.188.778c.044.359.073.722.073 1.093s-.029.734-.073 1.093zm-6.739-4.871c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"
        fill="#857676"
      />
      <path
        d="m61.196 5.02-5.981-1.196-1.196 5.98 1.961.393.539-2.692c.969 2.016 1.481 4.238 1.481 6.495 0 3.448-1.138 6.69-3.29 9.375l1.561 1.251c2.405-3.001 3.729-6.774 3.729-10.626 0-2.619-.605-5.201-1.756-7.531l2.56.512z"
        fill="#857676"
      />
      <path
        d="m23.707 13.293-1.414 1.414 1.359 1.359c-.55-.035-1.101-.066-1.652-.066-7.736 0-15.018 3.411-19.978 9.359l1.536 1.281c4.579-5.491 11.3-8.64 18.442-8.64.509 0 1.017.029 1.525.061l-1.232 1.232 1.414 1.414 3.707-3.707z"
        fill="#857676"
      />
    </SvgIcon>
  );
}

function ExpandedIcon(props) {
  return (
    <SvgIcon
      fontSize="inherit"
      viewBox="0 0 64 64"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path
        d="m36.787 44.422c-.163.998-.422 1.962-.771 2.884l3.131 2.837c-.439.924-.939 1.812-1.516 2.646l-4.02-1.296c-.634.775-1.344 1.484-2.119 2.118l1.296 4.02c-.834.577-1.722 1.076-2.646 1.516l-2.837-3.131c-.922.349-1.885.608-2.884.771l-.893 4.136c-.505.04-1.012.077-1.528.077s-1.023-.037-1.529-.077l-.893-4.136c-.998-.163-1.962-.422-2.884-.771l-2.837 3.131c-.924-.439-1.812-.939-2.646-1.516l1.296-4.02c-.775-.634-1.484-1.344-2.118-2.118l-4.02 1.296c-.577-.834-1.076-1.722-1.516-2.646l3.131-2.837c-.349-.922-.608-1.885-.771-2.884l-4.136-.893c-.04-.506-.077-1.013-.077-1.529s.037-1.023.077-1.529l4.136-.893c.163-.998.422-1.962.771-2.884l-3.131-2.837c.439-.924.939-1.812 1.516-2.646l4.02 1.296c.634-.775 1.344-1.484 2.119-2.118l-1.296-4.02c.834-.577 1.722-1.076 2.646-1.516l2.837 3.131c.922-.349 1.885-.608 2.884-.771l.893-4.136c.505-.04 1.012-.077 1.528-.077s1.023.037 1.529.077l.893 4.136c.998.163 1.962.422 2.884.771l2.837-3.131c.924.439 1.812.939 2.646 1.516l-1.296 4.02c.775.634 1.484 1.344 2.118 2.119l4.02-1.296c.577.834 1.076 1.722 1.516 2.646l-3.131 2.837c.349.922.608 1.885.771 2.884l4.136.893c.04.505.077 1.012.077 1.528s-.037 1.023-.077 1.529zm-14.787-12.422c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z"
        fill="#88E51C"
      />
      <path
        d="m50.659 16.305c-.156.517-.36 1.013-.611 1.48l1.579 3.026c-.533.674-1.141 1.282-1.815 1.815l-3.026-1.579c-.467.252-.963.456-1.48.611l-1.024 3.26c-.422.05-.848.082-1.282.082s-.86-.032-1.281-.081l-1.024-3.26c-.517-.155-1.013-.36-1.48-.611l-3.026 1.579c-.674-.533-1.282-1.141-1.815-1.815l1.579-3.026c-.252-.467-.456-.963-.611-1.48l-3.26-1.024c-.05-.422-.082-.848-.082-1.282s.032-.86.081-1.281l3.26-1.024c.155-.517.36-1.013.611-1.48l-1.579-3.026c.533-.674 1.141-1.282 1.815-1.815l3.026 1.579c.467-.252.963-.456 1.48-.611l1.024-3.26c.422-.05.848-.082 1.282-.082s.86.032 1.281.081l1.024 3.26c.517.155 1.013.36 1.48.611l3.026-1.579c.674.533 1.282 1.141 1.815 1.815l-1.579 3.026c.252.467.456.963.611 1.48l3.26 1.024c.05.422.082.848.082 1.282s-.032.86-.081 1.281zm-7.659-6.305c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
        fill="#88E51C"
      />
      <path
        d="m58.739 38.871c-.154.555-.371 1.081-.649 1.572l.995 2.094c-.452.577-.971 1.096-1.548 1.548l-2.094-.995c-.49.278-1.017.495-1.572.649l-.778 2.188c-.359.044-.722.073-1.093.073s-.734-.029-1.093-.073l-.778-2.188c-.555-.154-1.081-.371-1.572-.649l-2.094.995c-.577-.452-1.096-.971-1.548-1.548l.995-2.094c-.278-.49-.495-1.017-.649-1.571l-2.188-.778c-.044-.36-.073-.723-.073-1.094s.029-.734.073-1.093l2.188-.778c.154-.555.371-1.081.649-1.571l-.995-2.094c.452-.577.971-1.096 1.548-1.548l2.094.995c.49-.278 1.017-.495 1.572-.649l.778-2.188c.359-.045.722-.074 1.093-.074s.734.029 1.093.073l.778 2.188c.555.154 1.081.371 1.572.649l2.094-.995c.577.452 1.096.971 1.548 1.548l-.995 2.094c.278.49.495 1.017.649 1.572l2.188.778c.044.359.073.722.073 1.093s-.029.734-.073 1.093zm-6.739-4.871c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"
        fill="#88E51C"
      />
      <path
        d="m61.196 5.02-5.981-1.196-1.196 5.98 1.961.393.539-2.692c.969 2.016 1.481 4.238 1.481 6.495 0 3.448-1.138 6.69-3.29 9.375l1.561 1.251c2.405-3.001 3.729-6.774 3.729-10.626 0-2.619-.605-5.201-1.756-7.531l2.56.512z"
        fill="#88E51C"
      />
      <path
        d="m23.707 13.293-1.414 1.414 1.359 1.359c-.55-.035-1.101-.066-1.652-.066-7.736 0-15.018 3.411-19.978 9.359l1.536 1.281c4.579-5.491 11.3-8.64 18.442-8.64.509 0 1.017.029 1.525.061l-1.232 1.232 1.414 1.414 3.707-3.707z"
        fill="#88E51C"
      />
    </SvgIcon>
  );
}

function EndIcon(props) {
  return (
    <SvgIcon
      fontSize="inherit"
      viewBox="0 0 484.371 484.371"
      style={{ width: 10, height: 10 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path
        d="m484.371 282.306v-80.24l-59.022-12.535c-3.94-13.784-9.464-27.065-16.463-39.577l32.92-50.623-56.748-56.748-50.623 32.92c-12.504-7.02-25.794-12.536-39.594-16.433l-12.535-59.07h-80.24l-12.535 59.022c-13.784 3.94-27.065 9.464-39.577 16.463l-50.623-32.92-56.748 56.749 32.92 50.623c-6.999 12.512-12.523 25.793-16.463 39.577l-59.04 12.552v80.24l59.07 12.535c3.885 13.792 9.387 27.076 16.392 39.577l-32.92 50.623 56.748 56.748 50.623-32.92c12.512 6.999 25.793 12.523 39.577 16.463l12.576 59.04h80.24l12.535-59.07c13.782-3.916 27.063-9.416 39.577-16.392l50.623 32.92 56.748-56.748-32.92-50.623c6.993-12.525 12.508-25.82 16.433-39.618zm-242.15 64.321c-57.681.02-104.457-46.724-104.477-104.406-.02-57.681 46.724-104.457 104.406-104.477 57.681-.02 104.457 46.724 104.477 104.406.01 57.677-46.729 104.448-104.406 104.477z"
        fill="#E51C24"
      />
    </SvgIcon>
  );
}

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    "& .close": {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
  },
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
  root: {
    height: 100,
    flexGrow: 1,
    marginLeft: 16,
  },
  label: {
    fontSize: "0.7rem",
    fontWeight: "bolder",
  },
  labelSub: {
    fontSize: "0.7rem",
    fontStyle: "italic",
  },
  labelLev2: {
    fontSize: "0.7rem",
    //fontWeight: "bold",
  },
});

export default function CustomizedTreeView({
  ProductID,
  ProductName,
  // onCatClick,
  onAddCat2,
  onAddCat3,
  onAddCat4,
  onEditCat1,
  onEditCat2,
  onEditCat3,
  onEditCat4,
  CatData,
}) {
  const classes = useStyles();
  const [treeData, setTreeData] = useState([]);
  const [treeStage1, setTreeStage1] = useState([]);
  const [expTreeNodes, setExpTreeNodes] = useState(["1"]);

  useEffect(() => {
    // const CatArray = [CatData];
    setTreeData(CatData);
  }, [CatData]);

  useEffect(() => {
    if (treeData.length > 0) {
      let expandedTreeNodes = ["1"];
      let prevS1Item = "",
        prevS2Item = "",
        prevS3Item = "",
        menuItem,
        s1ActionItems = ["Add Cat 2", "Edit Cat 1"],
        s2ActionItems = ["Add Cat 3", "Edit Cat 2"],
        s3ActionItems = ["Add Cat 4", "Edit Cat 3"],
        s4ActionItems = ["Edit Cat 4"],
        s1Actions = [onAddCat2, onEditCat1],
        s2Actions = [onAddCat3, onEditCat2],
        s3Actions = [onAddCat4, onEditCat3],
        s4Actions = [onEditCat4];
      const renderedStage1 = treeData.map((s1item) => {
        const renderedStage2 = treeData.map((s2item) => {
          if (
            s1item.ProductCat1ID === s2item.ProductCat1ID &&
            s2item.ProductCat2ID !== null
          ) {
            const renderedStage3 = treeData.map((s3item) => {
              if (
                s2item.ProductCat2ID === s3item.ProductCat2ID &&
                s3item.ProductCat3ID !== null
              ) {
                const renderedStage4 = treeData.map((s4item) => {
                  if (
                    s3item.ProductCat3ID === s4item.ProductCat3ID &&
                    s4item.ProductCat4ID !== null
                  ) {
                    menuItem = (
                      <StyledTreeItem
                        classes={{ label: classes.labelSub }}
                        nodeId={s4item.ProductCat4ID}
                        label={s4item.ProductCat4}
                        // onLabelClick={(e) =>
                        //   onCatClick(s3item.ProductCat3ID, "Cat3")
                        // }
                      />
                    );
                    return (
                      <ContextMenu
                        key={s4item.ProductCat4ID}
                        menuItem={menuItem}
                        actionItems={s4ActionItems}
                        actions={s4Actions}
                        idKey={s4item.ProductCat4ID}
                      />
                    );
                  } else {
                    return (
                      <React.Fragment
                        key={s3item.ProductCat3ID + s4item.ProductCat4ID}
                      />
                    );
                  }
                });

                if (prevS3Item !== s3item.ProductCat3ID) {
                  prevS3Item = s3item.ProductCat3ID;
                  expandedTreeNodes.push(prevS3Item);
                  menuItem = (
                    <StyledTreeItem
                      classes={{ label: classes.labelSub }}
                      nodeId={s3item.ProductCat3ID}
                      label={s3item.ProductCat3}
                      // onLabelClick={(e) =>
                      //   onCatClick(s3item.ProductCat3ID, "Cat3")
                      // }
                    >
                      {renderedStage4}
                    </StyledTreeItem>
                  );
                  return (
                    <ContextMenu
                      key={s3item.ProductCat3ID}
                      menuItem={menuItem}
                      actionItems={s3ActionItems}
                      actions={s3Actions}
                      idKey={s3item.ProductCat3ID}
                    />
                  );
                } else {
                  return (
                    <React.Fragment
                      key={s2item.ProductCat2ID + s3item.ProductCat3ID}
                    />
                  );
                }
              } else {
                return (
                  <React.Fragment
                    key={s1item.ProductCat1ID + s2item.ProductCat2ID}
                  />
                );
              }
            });

            if (prevS2Item !== s2item.ProductCat2ID) {
              prevS2Item = s2item.ProductCat2ID;
              expandedTreeNodes.push(prevS2Item);
              menuItem = (
                <StyledTreeItem
                  classes={{ label: classes.labelLev2 }}
                  nodeId={s2item.ProductCat2ID}
                  label={s2item.ProductCat2}
                  // onLabelClick={(e) =>
                  //   onCatClick(s2item.ProductCat2ID, "Cat2")
                  // }
                >
                  {renderedStage3}
                </StyledTreeItem>
              );
              return (
                <ContextMenu
                  key={s2item.ProductCat2ID}
                  menuItem={menuItem}
                  actionItems={s2ActionItems}
                  actions={s2Actions}
                  idKey={s2item.ProductCat2ID}
                />
              );
            }
          } else {
            return (
              <React.Fragment
                key={s1item.ProductCat1ID + s2item.ProductCat2ID}
              />
            );
          }
        });
        if (prevS1Item !== s1item.ProductCat1ID) {
          prevS1Item = s1item.ProductCat1ID;
          expandedTreeNodes.push(prevS1Item);

          menuItem = (
            <StyledTreeItem
              classes={{ label: classes.label }}
              key={s1item.ProductCat1ID}
              nodeId={s1item.ProductCat1ID}
              label={s1item.ProductCat1}
              // onLabelClick={(e) => onCatClick(s1item.ProductCat1ID, "Cat1")}
            >
              {renderedStage2}
            </StyledTreeItem>
          );
          return (
            <ContextMenu
              key={s1item.ProductCat1ID}
              menuItem={menuItem}
              actionItems={s1ActionItems}
              actions={s1Actions}
              idKey={s1item.ProductCat1ID}
            />
          );
        } else {
          return <React.Fragment key={s1item.ProductCat1ID + Math.random()} />;
        }
      });
      setExpTreeNodes(expandedTreeNodes);
      setTreeStage1(renderedStage1);
    }
  }, [treeData]);

  return (
    <TreeView
      className={classes.root}
      defaultExpanded={["1"]}
      defaultCollapseIcon={<ExpandedIcon />}
      defaultExpandIcon={<PlusSquare />}
      defaultEndIcon={<EndIcon />}
      // expanded={expTreeNodes}
    >
      <StyledTreeItem
        classes={{ label: classes.label }}
        nodeId="1"
        label={ProductName}
        // onLabelClick={(e) => onCatClick(ProductID, "Root")}
      >
        {treeStage1}
      </StyledTreeItem>
    </TreeView>
  );
}
